import React, { useState, useEffect } from 'react';
import { FaYoutube, FaGoogle, FaFacebook, FaInstagram, FaPhotoVideo } from 'react-icons/fa';
import { database, ref as dbRef, onValue } from '../firebase';

const Commission = () => {
  const [activities, setActivities] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Define activity metadata (icons and colors)
  const activityMetadata = [
    { id: 1, name: 'Watch Video', icon: <FaPhotoVideo className="text-blue-500" />, color: 'bg-blue-50', borderColor: 'border-blue-200' },
    { id: 2, name: 'Photo', icon: <FaPhotoVideo className="text-purple-500" />, color: 'bg-purple-50', borderColor: 'border-purple-200' },
    { id: 3, name: 'YouTube', icon: <FaYoutube className="text-red-500" />, color: 'bg-red-50', borderColor: 'border-red-200' },
    { id: 4, name: 'Google', icon: <FaGoogle className="text-green-500" />, color: 'bg-green-50', borderColor: 'border-green-200' },
    { id: 5, name: 'Facebook', icon: <FaFacebook className="text-blue-600" />, color: 'bg-blue-50', borderColor: 'border-blue-200' },
    { id: 6, name: 'Instagram', icon: <FaInstagram className="text-pink-500" />, color: 'bg-pink-50', borderColor: 'border-pink-200' },
  ];

  // Fetch commission points and time from Firebase
  useEffect(() => {
    const commissionsRef = dbRef(database, 'videoplayer/Commissions/1');

    const unsubscribe = onValue(
      commissionsRef,
      (snapshot) => {
        const commissionData = snapshot.val();
        if (commissionData) {
          // Map Firebase data to activities array
          const fetchedActivities = activityMetadata.map((meta) => ({
            ...meta,
            points: commissionData[
              meta.name === 'Watch Video' ? 'watchVideoPoints' :
              meta.name === 'Photo' ? 'photoPoints' :
              meta.name === 'YouTube' ? 'youtubePoints' :
              meta.name === 'Instagram' ? 'instagramPoints' :
              meta.name === 'Facebook' ? 'facebookPoints' :
              meta.name === 'Google' ? 'googlePoints' : ''
            ] || 0,
            time: commissionData[
              meta.name === 'Watch Video' ? 'watchVideoTime' :
              meta.name === 'Photo' ? 'photoTime' :
              meta.name === 'YouTube' ? 'youtubeTime' :
              meta.name === 'Instagram' ? 'instagramTime' :
              meta.name === 'Facebook' ? 'facebookTime' :
              meta.name === 'Google' ? 'googleTime' : ''
            ] || 'N/A'
          }));
          setActivities(fetchedActivities);
          setLoading(false);
        } else {
          // If no data, set activities with zero points and N/A time
          setActivities(activityMetadata.map((meta) => ({ ...meta, points: 0, time: 'N/A' })));
          setLoading(false);
        }
      },
      (error) => {
        console.error('Error fetching commissions:', error);
        setError('Failed to load commission points. Please try again later.');
        setLoading(false);
      }
    );

    return () => unsubscribe();
  }, []);

  return (
    <main className="min-h-screen bg-gray-100 dark:bg-gray-900 text-gray-900 dark:text-gray-100 py-8 px-4 sm:px-6 lg:px-8">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 dark:text-white">Earn Points by Watching</h1>
        </div>

        {loading ? (
          <div className="flex justify-center py-12">
            <div className="animate-spin rounded-full h-10 w-10 border-t-4 border-red-600"></div>
          </div>
        ) : error ? (
          <div className="text-center py-10 text-red-500 dark:text-red-400">
            <p>{error}</p>
          </div>
        ) : (
          <>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {activities.map((activity, index) => (
                <div
                  key={activity.id}
                  className={`relative p-5 rounded-lg shadow-md hover:shadow-lg transition-all duration-300 ${activity.color} ${activity.borderColor} border transform hover:-translate-y-1`}
                  style={{
                    animation: `fadeInUp 0.5s ease-out ${index * 0.1}s forwards`,
                    opacity: 0,
                  }}
                >
                  <div className="flex items-center mb-4">
                    <div className="flex items-center justify-center h-10 w-10 rounded-full bg-white shadow mr-3">
                      {activity.icon}
                    </div>
                    <h3 className="text-lg font-semibold text-gray-900 dark:text-white">{activity.name}</h3>
                  </div>
                  <div className="space-y-2">
                    <div>
                      <p className="text-sm text-gray-600 dark:text-gray-300">Points</p>
                      <p className="text-2xl font-bold text-gray-900 dark:text-white">{activity.points} pts</p>
                    </div>
                    <div>
                      <p className="text-sm text-gray-600 dark:text-gray-300 font-semibold">Watch for {activity.time}</p>
                      <p className="text-lg font-semibold text-gray-900 dark:text-white"> Mintues to earn {activity.points} pts</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </>
        )}

        <style jsx global>{`
          @keyframes fadeInUp {
            from {
              opacity: 0;
              transform: translateY(20px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }
        `}</style>
      </div>
    </main>
  );
};

export default Commission;